// import { selector } from 'recoil';
// import APIService from '../../APIService';
// import { Apis } from '../../app.constants';
// import { RecoilAtomKey } from '../../recoilConstantKey';
// import { generateFilterKey } from '../../../utils/helper';
// import { leadsTableStateAtom } from './index.ts';
// import { removeFormLeadsFromLocalStorage } from '../../../utils/notificationStorage.ts';

// const generateDynamicFilterString = (dynamicFilters) => {
//   try {
//     return Object.keys(dynamicFilters)
//       .sort()
//       .filter(
//         (key) =>
//           dynamicFilters[key] !== undefined &&
//           dynamicFilters[key] !== null &&
//           dynamicFilters[key] !== ''
//       )
//       .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(dynamicFilters[key])}`)
//       .join('&');
//   } catch (error) {
//     console.warn(error);
//     return '';
//   }
// };

// export const fetchLeadDataSelector = selector({
//   key: RecoilAtomKey.fetchLeadDataSelectorKey,
//   get: async ({ get }) => {
//     const state = get(leadsTableStateAtom);
//     const filterKey = generateFilterKey(state.filters);
//     if (state?.filters?.leads_form_id) {
//       removeFormLeadsFromLocalStorage(state?.filters?.leads_form_id);
//     }
//     // Serve from cache if available
//     if (state.cache[filterKey]) {
//       return {
//         data: state.cache[filterKey],
//         totalCount: state.totalCountCache[filterKey],
//         uniquePhoneCount: state?.uniqueCountCache[filterKey],
//         isCampaignOwner:
//           state?.isCampaignOwnerCache?.[filterKey] ?? state?.isCampaignOwner ?? false,
//         fromCache: true,
//       };
//     }

//     try {
//       if (!state?.filters?.campaign_id || !state?.filters?.leads_form_id) {
//         return 0;
//       }

//       // keep 0-based in state; send 1-based to API exactly once here
//       const page0 =
//         typeof state?.filters?.page === 'number' && !Number.isNaN(state.filters.page)
//           ? state.filters.page
//           : 0;
//       const apiPage = page0 + 1;

//       const limit = state?.filters?.limit || 10;
//       const start_date = state?.filters?.start_date || '';
//       const end_date = state?.filters?.end_date || '';
//       const status = state?.filters?.status || '';
//       const search = state?.filters?.search || '';

//       // new filters
//       const lead_assigned_to = state?.filters?.lead_assigned_to || '';
//       const is_pending =
//         typeof state?.filters?.isPending === 'boolean' ? state.filters.isPending : '';

//       let params =
//         `?campaign_id=${state.filters.campaign_id}` +
//         `&leads_form_id=${state.filters.leads_form_id}` +
//         `&page=${apiPage}` +
//         `&limit=${limit}` +
//         `&start_date=${start_date}` +
//         `&end_date=${end_date}` +
//         `&status=${encodeURIComponent(status)}` +
//         `&search=${encodeURIComponent(search)}` +
//         `&lead_assigned_to=${encodeURIComponent(lead_assigned_to)}` +
//         `&is_pending=${is_pending}`;

//       if (state?.filters?.sort_type && state?.filters?.sort_by) {
//         params += `&sort_type=${state.filters.sort_type}&sort_by=${state.filters.sort_by}`;
//       }

//       // const dynamicFilterString = generateDynamicFilterString(state?.filters?.dynamicFilters || []);
//       // if (dynamicFilterString) {
//       //   params += `&${dynamicFilterString}`;
//       // }
//       const dynamicFilterString = JSON.stringify(state?.filters?.dynamicFilters || '');
//       if (dynamicFilterString) {
//         params += `&data_filters=${dynamicFilterString}`;
//       }

//       const response = await APIService.get(`${Apis.getB2b2cLeads}${params}`);
//       if (response?.status === 200) {
//         return {
//           data: response?.data?.list || [],
//           totalCount: response?.data?.count || 0,
//           uniquePhoneCount: response?.data?.unique_phone_count || 0,
//           isCampaignOwner: !!response?.data?.is_campaign_owner,
//           fromCache: false,
//         };
//       } else {
//         return { data: [], totalCount: 0, isCampaignOwner: false, fromCache: false };
//       }
//     } catch (error) {
//       return { data: [], totalCount: 0, isCampaignOwner: false, fromCache: false };
//     }
//   },
// });

// recoil/selectors/leadSelector.ts
import { selector, selectorFamily } from 'recoil';
import APIService from '../../APIService';
import { Apis } from '../../app.constants';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { removeFormLeadsFromLocalStorage } from '../../../utils/notificationStorage.ts';
import { LeadDataResponse, LeadTableFilters } from '../../../interfaces/Leads.interface.ts';
import { leadsTableStateAtom } from './index.ts';

// export const fetchLeadDataSelector = selectorFamily({
//   key: RecoilAtomKey.fetchLeadDataSelectorKey,
//   get:
//     ({ filtersParams }) =>
//     async () => {
//       if (filtersParams?.leads_form_id) {
//         removeFormLeadsFromLocalStorage(filtersParams?.leads_form_id);
//       }

//       try {
//         if (!filtersParams?.campaign_id || !filtersParams?.leads_form_id) {
//           return { data: [], totalCount: 0, fromCache: false };
//         }

//         const page0 =
//           typeof filtersParams?.page === 'number' && !Number.isNaN(filtersParams.page)
//             ? filtersParams.page
//             : 0;
//         const apiPage = page0 + 1;
//         const limit = filtersParams?.limit || 25;
//         const offset = filtersParams?.offset || 0;

//         const params = new URLSearchParams({
//           campaign_id: filtersParams.campaign_id,
//           leads_form_id: filtersParams.leads_form_id,
//           page: apiPage.toString(),
//           limit: limit.toString(),
//           offset: offset.toString(),
//           start_date: filtersParams?.start_date || '',
//           end_date: filtersParams?.end_date || '',
//           status: filtersParams?.status || '',
//           search: filtersParams?.search || '',
//           lead_assigned_to: filtersParams?.lead_assigned_to || '',
//           is_pending:
//             typeof filtersParams?.isPending === 'boolean' ? String(filtersParams.isPending) : '',
//         });

//         if (filtersParams?.sort_type && filtersParams?.sort_by) {
//           params.append('sort_type', filtersParams.sort_type);
//           params.append('sort_by', filtersParams.sort_by);
//         }

//         if (filtersParams?.dynamicFilters) {
//           params.append('data_filters', JSON.stringify(filtersParams.dynamicFilters));
//         }

//         const response = await APIService.get(`${Apis.getB2b2cLeads}?${params.toString()}`);

//         if (response?.status === 200) {
//           return {
//             data: response?.data?.list || [],
//             totalCount: response?.data?.count || 0,
//             uniquePhoneCount: response?.data?.unique_phone_count || 0,
//             isCampaignOwner: !!response?.data?.is_campaign_owner,
//             fromCache: false,
//           };
//         }
//         return { data: [], totalCount: 0, fromCache: false };
//       } catch (error) {
//         console.warn(error);
//         return { data: [], totalCount: 0, fromCache: false };
//       }
//     },
// });

export const leadsActionSelector = selector({
  key: RecoilAtomKey.fetchLeadDataSelectorKey,
  get: ({ get }) => get(leadsTableStateAtom),

  set: ({ get, set }, action: { type: string; payload: any }) => {
    const current = get(leadsTableStateAtom);

    if (!action || typeof action !== 'object') return;

    switch (action?.type) {
      case 'add': {
        if (!action?.payload) return;
        if (action?.payload?.leads_form_id !== current?.filters?.leads_form_id) return;
        removeFormLeadsFromLocalStorage(current?.filters?.leads_form_id);
        const newLead = action.payload;
        set(leadsTableStateAtom, {
          ...current,
          data: [newLead, ...current.data],
          totalCount: current.totalCount + 1,
        });
        break;
      }

      /** ♻️ Update **/
      case 'update': {
        const updated = action.payload;
        set(leadsTableStateAtom, {
          ...current,
          data: (current.data ?? []).map((lead) =>
            lead?.lead_id === updated?.lead_id ? { ...lead, ...updated } : lead
          ),
        });
        break;
      }

      /** ❌ Delete **/
      case 'delete': {
        const idToDelete = action?.payload?.lead_id;
        set(leadsTableStateAtom, {
          ...current,
          data: current.data.filter((lead) => lead?.lead_id !== idToDelete),
          totalCount: current?.totalCount - 1,
        });
        break;
      }
      case 'bulk_update': {
        const updatedLeadsArray = action.payload; // Array of updated lead objects
        const updatedLeadsMap = new Map();
        updatedLeadsArray.forEach((lead: any) => {
          updatedLeadsMap.set(lead?.lead_id, lead);
        });
        set(leadsTableStateAtom, {
          ...current,
          data: (current.data ?? []).map((lead:any) =>
            updatedLeadsMap.has(lead?.lead_id)
              ? { ...lead, ...updatedLeadsMap.get(lead?.lead_id) }
              : lead
          ),
        });
        break;
      } 
      default:
        console.warn('Unknown leadsSelector action type:', action?.type);
    }
  },
});

export const fetchLeadData = async (filtersParams: LeadTableFilters) => {
  if (filtersParams?.leads_form_id) {
    removeFormLeadsFromLocalStorage(filtersParams?.leads_form_id);
  }

  try {
    if (!filtersParams?.campaign_id || !filtersParams?.leads_form_id) {
      return { data: [], totalCount: 0, uniquePhoneCount: 0, fromCache: false };
    }

    // const page0 =
    //   typeof filtersParams?.page === 'number' && !Number.isNaN(filtersParams.page)
    //     ? filtersParams.page
    //     : 0;
    // const apiPage = page0 + 1;
    const limit = filtersParams?.limit || 100;
    const offset = filtersParams?.offset || 0;

    const params = new URLSearchParams({
      campaign_id: filtersParams.campaign_id,
      leads_form_id: filtersParams.leads_form_id,
      // page: apiPage.toString(),
      limit: limit.toString(),
      offset: offset.toString(),
      start_date: filtersParams?.start_date || '',
      end_date: filtersParams?.end_date || '',
      status: filtersParams?.status || '',
      search: filtersParams?.search || '',
      lead_assigned_to: filtersParams?.lead_assigned_to || '',
      is_pending:
        typeof filtersParams?.isPending === 'boolean' ? String(filtersParams.isPending) : '',
      include_count: 'true',
      include_unique_count: 'true',
    });

    if (filtersParams?.sort_type && filtersParams?.sort_by) {
      params.append('sort_type', filtersParams.sort_type);
      params.append('sort_by', filtersParams.sort_by);
    }

    if (filtersParams?.dynamicFilters) {
      params.append('data_filters', JSON.stringify(filtersParams.dynamicFilters));
    }

    const response = (await APIService.get(
      `${Apis.getB2b2cLeads}?${params.toString()}`
    )) as LeadDataResponse;

    if (response?.status === 200) {
      return {
        data: response?.data?.list || [],
        totalCount: response?.data?.count || 0,
        uniquePhoneCount: response?.data?.unique_phone_count || 0,
        isCampaignOwner: !!response?.data?.is_campaign_owner,
        fromCache: false,
      };
    }

    return { data: [], totalCount: 0, uniquePhoneCount: 0, fromCache: false };
  } catch (error) {
    console.warn(error);
    return { data: [], totalCount: 0, uniquePhoneCount: 0, fromCache: false };
  }
};
